import React from 'react';
import classNames from 'classnames';

import Price from '../../Price';
import PointsForPurchase from '../../Rewards/PointsForPurchase/PointsForPurchase';
import Stars from '../Reviews/Stars/Stars';

import { createMetaFieldsMap } from '../../../utils';

const ns = `product-intro`;

const PDPIntro = ({
	className,
	product,
	variant,
}) => {
	const productId = product.shopifyId.split('/').pop();
	const metafieldsMap = createMetaFieldsMap(product.metafields);

	const rootClassnames = classNames({
		[`${ ns }`]: true,
		[className]: className,
	});

	return (
		<div className={`${ rootClassnames }`}>
			<div className={`${ ns }__title-price`}>
				<h1 className={`${ ns }__title`}>{product.title}</h1>
				<Price
					currencyCode={product.priceRange.minVariantPrice.currencyCode}
					price={variant.price}
					compareAtPrice={variant.compareAtPrice}
				/>
			</div>
			{metafieldsMap?.custom?.subtitle && (
				<div className={`${ ns }__subtitle`}>
					<p>{metafieldsMap.custom.subtitle}</p>
				</div>
			)}
			{metafieldsMap?.custom?.short_description && (
				<div className={`${ ns }__short-description`}>
					<p>{metafieldsMap.custom.short_description}</p>
				</div>
			)}
			<div className={`${ ns }__reviews-rewards`}>
				<div className={`${ ns }__reviews`}>
					<a href={`#reviewsComponent`}>
						<Stars productId={productId} />
					</a>
				</div>
				<div className={`${ ns }__rewards`}>
					<PointsForPurchase
						price={variant.price}
					/>
				</div>
			</div>
		</div>
	);
};

export default PDPIntro;
